/**
 * Checks whether or not an element is a Number that larger than 0 and smaller than Infinity
 *
 * @param e element
 * @returns {boolean}
 */
export const validNumber = (e: number) =>
    !Number.isNaN(e) && 0 < e && Number.POSITIVE_INFINITY > e;

/**
 * Sets the state asynchronously by resolving it through a promise
 *
 * @param self
 * @param state
 * @returns {Promise<unknown>}
 */
export const asyncState = (self: any, state: any) =>
    new Promise((resolve) => self.setState(state, resolve));

export const parseQueryString = (
    value: string | number | (string | number | null)[] | null
): number => {
    if (Array.isArray(value)) {
        return 0;
    }

    const parsedNumber = parseFloat(value as string);
    return validNumber(parsedNumber) ? parsedNumber : 0;
};
